import React from "react";
import "./styles.scss";
import BackButton from "app/features/BackButton";
const NotFoundPage: React.FC = () => {
  return (
    <div className="nf-wrapper">
      <BackButton to="/" />
      <p className="nf-content">404</p>
      <p>страница не найдена</p>
    </div>
  );
};

export default NotFoundPage;
